const config = {
  apiGateway: {
    URL: import.meta.env.VITE_API_URL || "http://localhost:3000",
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID || "",
    APP_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
    IDENTITY_POOL_ID: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || "",
  },
  okta: {
    ISSUER: import.meta.env.VITE_OKTA_ISSUER || "",
    CLIENT_ID: import.meta.env.VITE_OKTA_CLIENT_ID || "",
  },
  authMode: (import.meta.env.VITE_AUTH_MODE || "dual") as "okta" | "cognito" | "dual",
  stage: import.meta.env.VITE_STAGE || "dev",
};

export default config;
